import { CookiePolicyPage } from '@pages/cookie-policy/CookiePolicyPage';
import { InternalLoginPage } from '@pages/internal-login/InternalLoginPage';
import { LandingPage } from '@pages/landing/LandingPage';
import { RegisterUserPage } from '@pages/register-user/RegisterUserPage';
import { ErrorPage } from '@shared/components/error-pages/ErrorPage';
import { FeatureFlagGuard } from '@shared/components/route-guards/feature-flag-guard/FeatureFlagGuard';
import { PublicRoute } from '@shared/components/route-guards/public-route/PublicRoute';
import { Navigate, RouteObject } from 'react-router-dom';

import { APP_ROUTES } from './routes.constants';

/**
 * Public routes - accessible without authentication
 * Includes: Landing page, Cookie Policy
 *
 * Error pages (403, 404, 500, session expired, etc.) are rendered INLINE by guards,
 * providers and AppContent, not at dedicated URLs. This prevents bookmarkable/shareable
 * dead-end error URLs.
 */
export const publicRoutes: RouteObject[] = [
  {
    path: APP_ROUTES.DEFAULT,
    element: (
      <PublicRoute>
        <LandingPage />
      </PublicRoute>
    ),
  },

  {
    path: APP_ROUTES.REGISTER,
    element: (
      <PublicRoute>
        <FeatureFlagGuard flag="publicAccountCreationPageEnabled">
          <RegisterUserPage />
        </FeatureFlagGuard>
      </PublicRoute>
    ),
  },

  {
    path: APP_ROUTES.COOKIE_POLICY,
    element: <CookiePolicyPage />,
  },

  {
    // Legacy URL from the old hard-redirect flow; may still be in users' history/bookmarks.
    path: APP_ROUTES.SESSION_EXPIRED,
    element: <Navigate to={APP_ROUTES.DEFAULT} replace />,
  },
  {
    path: APP_ROUTES.LOGIN_INTERNAL,
    element: <InternalLoginPage />,
  },
];

/**
 * Catch-all route — must be spread LAST in router config.
 * Separated from publicRoutes for explicit ordering in router.tsx.
 */
export const catchAllRoute = [
  {
    path: '*',
    element: <ErrorPage type="not-found" />,
  },
];
